module.exports = __webpack_public_path__ + "img/yiyao_gmp_suoluetu.88cf2310.png";